import Swiper from "swiper/bundle";

export function initVideosSwipers(scope = document) {
  scope.querySelectorAll("[data-kijk-mee-root]").forEach((root) => {
    const el = root.querySelector(".js-kijk-mee-swiper");
    const fill = root.querySelector(".js-kijk-mee-fill");
    if (!el) return;

    if (el._swiper) el._swiper.destroy(true, true);

    let data = {};
    try {
      data = JSON.parse(el.getAttribute("data-options") || "{}");
    } catch (_) { }

    const swiper = (el._swiper = new Swiper(el, {
      ...data,
      slideToClickedSlide: false,
      preventClicks: false,
      preventClicksPropagation: false,
      touchStartPreventDefault: false,

      navigation: {
        nextEl: root.querySelector(".kijk-mee-next"),
        prevEl: root.querySelector(".kijk-mee-prev"),
      },

      on: {
        init() {
          updateFill(this, fill);
          const parentSection = root.closest("section") || document;
          fetchVimeoCovers(parentSection);
          setupModalEvents(parentSection);
          setupAutoplayVideo(root);
        },
        setTranslate() {
          updateFill(this, fill);
        },
        transitionEnd() {
          updateFill(this, fill);
        },
      },
    }));

    function updateFill(sw, fillEl) {
      if (!fillEl) return;
      const p = Math.max(0, Math.min(1, sw.progress));
      fillEl.style.transform = `scaleX(${0.2 + p * 0.8})`;
    }

    function fetchVimeoCovers(container) {
      container.querySelectorAll("[data-vimeo-thumbnail]").forEach((img) => {
        const vimeoId = img.getAttribute("data-vimeo-thumbnail");
        if (!vimeoId) return;

        fetch(`https://vimeo.com/api/v2/video/${vimeoId}.json`)
          .then((res) => res.json())
          .then((data) => {
            if (data && data[0]) {
              const url = data[0].thumbnail_large || data[0].thumbnail_medium;
              img.src = url;
            }
          })
          .catch((err) => console.error("Error fetching Vimeo thumbnail:", err));
      });
    }

    function setupModalEvents(container) {
      const modals = container.querySelectorAll(".js-kijk-mee-modal");
      modals.forEach((modal) => {
        if (modal.dataset.modalEventsBound === "true") return;
        modal.dataset.modalEventsBound = "true";

        const videoType = modal.getAttribute("data-video-type");
        const videoId = modal.getAttribute("data-video-id");
        const videoMp4 = modal.getAttribute("data-video-mp4");
        const contentWrap = modal.querySelector(".js-video-modal-content");

        if (!contentWrap) return;

        modal.addEventListener("show.bs.modal", () => {
          if (videoType === "youtube") {
            contentWrap.innerHTML = `
              <iframe
                class="w-100 h-100"
                src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1"
                allow="autoplay; encrypted-media; picture-in-picture"
                allowfullscreen
              ></iframe>
            `;
          } else if (videoType === "vimeo") {
            contentWrap.innerHTML = `
              <iframe
                class="w-100 h-100"
                src="https://player.vimeo.com/video/${videoId}?autoplay=1&playsinline=1"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
              ></iframe>
            `;
          } else if (videoType === "mp4") {
            contentWrap.innerHTML = `
              <video class="w-100 h-100 modal-video-lightbox__video" controls playsinline autoplay>
                <source src="${videoMp4}" type="video/mp4">
              </video>
            `;
          }
        });

        modal.addEventListener("hide.bs.modal", () => {
          contentWrap.innerHTML = "";
        });
      });
    }

    function setupAutoplayVideo(root) {
      const autoplayVideo = root.querySelector(".js-kijk-mee-autoplay");
      if (!autoplayVideo) return;

      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              autoplayVideo.play().catch((err) => console.log("Autoplay failed:", err));
            } else {
              autoplayVideo.pause();
            }
          });
        }, { threshold: 0.2 });
        observer.observe(root);
      } else {
        autoplayVideo.play().catch(() => {});
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", () => initVideosSwipers());
document.addEventListener("shopify:section:load", (event) => initVideosSwipers(event.target));